import React from "react";
// Material imports
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
const getStyles = theme => {
  var _theme$palette$button, _theme$palette$button2, _theme$palette$button3;
  return {
    loadingFooterContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 112
    },
    progress: {
      color: (_theme$palette$button = (_theme$palette$button2 = theme.palette.buttons) === null || _theme$palette$button2 === void 0 ? void 0 : (_theme$palette$button3 = _theme$palette$button2.submit) === null || _theme$palette$button3 === void 0 ? void 0 : _theme$palette$button3.backgroundColor) !== null && _theme$palette$button !== void 0 ? _theme$palette$button : theme.palette.primary.main
    }
  };
};
const LoadingFooter = () => {
  const theme = useTheme();
  const classes = React.useMemo(() => getStyles(theme), [theme]);
  return /*#__PURE__*/React.createElement("div", {
    style: classes.loadingFooterContainer
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    size: 32,
    style: classes.progress
  }));
};
export default LoadingFooter;